export default __webpack_public_path__ + "../staticImages/hvv_icon.png";